import { useEffect, useMemo, useState } from "react";

import { observer } from "mobx-react-lite";

import iconCameraRed from "../../../assets/images/100-camera-red.svg";
import iconCamera from "../../../assets/images/100-camera.svg";
import iconMicRed from "../../../assets/images/100-mic-red.svg";
import iconMic from "../../../assets/images/100-mic.svg";
import { useAuth } from "../../../contexts/authContext";
import { useJanusContext } from "../../../contexts/janus/JanusContext";
import { useMeetingDetailsStore } from "../../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../../hooks/useApi";
import { useUserMedia } from "../../../hooks/useUserMedia";

export const Controls = observer(() => {
  const { previewCamStream, previewMicStream, startPreviewStream, stopPreviewCamStream, stopPreviewMicStream } = useUserMedia();
  const { sendCurrentUserEvent } = useApi();
  const { meeting, participants } = useMeetingDetailsStore();
  const { userData } = useAuth();
  const { janusStore } = useJanusContext();

  const currentParticipantId = useMemo(() => participants.find((participant) => participant.user.email === userData.email)?.pid, []);

  const [isVideoStream, setIsVideoStream] = useState(!!previewCamStream);
  const [isAudioStream, setIsAudioStream] = useState(!!previewMicStream);

  useEffect(() => {
    setIsVideoStream(!!previewCamStream);
  }, [previewCamStream]);

  useEffect(() => {
    setIsAudioStream(!!previewMicStream);
  }, [previewMicStream]);

  const toggleMic = async () => {
    if (isAudioStream) {
      stopPreviewMicStream();
    }
    const muteState = isAudioStream ? "muted" : "unmuted";
    const response = await sendCurrentUserEvent({
      lwid: meeting.mid,
      pid: currentParticipantId,
      data: { audio_mute: muteState },
    });
    console.log(`${muteState} Audio res: `, response);
    if (!isAudioStream) {
      startPreviewStream({ audio: true, video: false });
    }
    janusStore.videoRoomStore.toggleMediaStream(null, "audio", isAudioStream ? "muted" : "unmuted");
  };

  const toggleCam = async () => {
    if (isVideoStream) {
      stopPreviewCamStream();
    }
    const muteState = isVideoStream ? "muted" : "unmuted";
    const response = await sendCurrentUserEvent({
      lwid: meeting.mid,
      pid: currentParticipantId,
      data: { video_mute: muteState },
    });
    console.log(`${muteState} Video res: `, response);
    if (!isVideoStream) {
      startPreviewStream({ audio: false, video: true });
    }
    // TODO: in scenario when both audio and video are muted, once unmute video - audio gets unmuted as well
    janusStore.videoRoomStore.toggleMediaStream(null, "video", isVideoStream ? "muted" : "unmuted");
  };

  return (
    <div className="meeting-controller-widget-items">
      <div className="align-items-center m-lr-8">
        <button onClick={toggleMic} className="m-r-6 icon-action">
          <img src={isAudioStream ? iconMic : iconMicRed} className="m-r-6 i i-mic i-24" alt="" />
        </button>
        <button onClick={toggleCam} className="icon-action">
          <img src={isVideoStream ? iconCamera : iconCameraRed} className="i i-camera i-24" alt="" />
        </button>
      </div>
    </div>
  );
});
